import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisationIndexCategory } from "../model/OrganisationIndexCategory";
import OrganisationIndexCategoryMapper from "../service/OrganisationIndexCategoryMapper";
import OrganisationIndexCategoryParamMapper from "../service/OrganisationIndexCategoryParamMapper";

export default class GetAllOrganisationIndexCategoriesInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisationIndexCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number) {
    return this.resource.execute(
      `organisations/${organisationId}/index-categories`,
      OrganisationIndexCategoryMapper,
      OrganisationIndexCategoryParamMapper
    );
  }
}
